// extracted by mini-css-extract-plugin
export var gif = "_ia-0";